import React from "react";
import { Globe, Printer, Puzzle, TabletSmartphone } from "lucide-react";
import { Translate } from "components/common/Translate/Translate";
import {ISection8UseCase, Section8UseCaseScaffold} from "components/features/CompressorCommon/Section8UseCaseScaffold";

const bestUseList: ISection8UseCase[] = [
    {
        title: "Speed-Up-Your-Store-Thumbnails-heading",
        subTitle: "Speed-Up-Your-Store-Thumbnails-sub-heading",
        icon: <Globe strokeWidth={1.5} width={30} height={30} />,
    },
    {
        title: "Optimize-Marketing-heading",
        subTitle: "Optimize-Marketing-sub-heading",
        icon: <Puzzle />,
    },
    {
        title: "Improve-Social-Media-heading",
        subTitle: "Improve-Social-Media-sub-heading",
        icon: <TabletSmartphone />,
    },
    {
        title: "Keep-Sites-Fast-heading",
        subTitle: "Keep-Sites-Fast-sub-heading",
        icon: <Printer />,
    },
];
const WebpResizerUseCase = () => {
    return (
        <Section8UseCaseScaffold
            title={<Translate keyName="best-usage-online-tool-title" />}
            useCases={bestUseList}
        />
    );
};

export default WebpResizerUseCase;
